import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const ParliamentLoadable = Loadable({
    loader: (): any => import('./Parliament').then((res) => res.Parliament),
    loading: <Loader/>,
});
